import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { AirTankNodeModel } from './AirTankNodeModel';
import { AirTankNodeWidget } from './AirTankNodeWidget';

export type AirTankType = NodeModelTypeEnum.DryAirTank | NodeModelTypeEnum.WetAirTank;

export class AirTankNodeFactory extends AbstractReactFactory {
  type: AirTankType;
  constructor(private isMainMap, type: AirTankType) {
    super(type);
    this.type = type;
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new AirTankNodeModel(this.type);
  }

  nodeUI(event) {
    return <AirTankNodeWidget engine={this.engine} node={event.model} width={126} height={216} type={this.type} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
